import { d as o } from "./descriptors.js";
import { f as r } from "./function-uncurry-this.js";
import { f as t } from "./function-call.js";
import { f as e } from "./fails.js";
import { o as s } from "./object-keys.js";
import "./object-get-own-property-symbols.js";
import "./object-property-is-enumerable.js";
import { t as i } from "./to-object.js";
import { i as n } from "./indexed-object.js";
import { __exports as a } from "../../../_virtual/object-get-own-property-symbols.js";
import { __exports as m } from "../../../_virtual/object-property-is-enumerable.js";
var f = Object.assign,
  p = Object.defineProperty,
  c = r([].concat),
  j = !f || e(function () {
    if (o && 1 !== f({
      b: 1
    }, f(p({}, "a", {
      enumerable: !0,
      get: function get() {
        p(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), {
      b: 2
    })).b) return !0;
    var r = {},
      t = {},
      e = Symbol(),
      i = "abcdefghijklmnopqrst";
    return r[e] = 7, i.split("").forEach(function (o) {
      t[o] = o;
    }), 7 != f({}, r)[e] || s(f({}, t)).join("") != i;
  }) ? function (r, e) {
    for (var f = i(r), p = arguments.length, j = 1, b = a.f, u = m.f; p > j;) for (var l, y = n(arguments[j++]), g = b ? c(s(y), b(y)) : s(y), v = g.length, d = 0; v > d;) l = g[d++], (!o || t(u, y, l)) && (f[l] = y[l]);
    return f;
  } : f;
export { j as o };